import { txList, getTxCount } from "@/config/apiServer/esdb";
import Rpc from "@/config/apiServer/chain33rpc";
import { getTransactionAnalysis } from "@/config/apiServer/scanner";
import { ref, reactive, Ref } from "vue";
import { TxType, PageType } from "@/types/types";
import { checkGroup } from "./common";
import { tradeAccuracy } from "@/utils/filters";

interface TradeMixins {
    loading: Ref<boolean>;
    txNotFound: Ref<boolean>;
    pages: PageType;
    txs: { list: TxType[] };
    trade: { state: boolean; detail: Record<string, unknown> };
    erc20Tokens: Ref<Record<string, unknown>>;
    getCount: () => Promise<void>;
    getTxList: () => Promise<void>;
    pageChange: (page: number) => void;
    sizeChange: (size: number) => void;
    getTradeDetail: (hash: string) => void;
}

export default (): TradeMixins => {
    const loading = ref(false);
    const txNotFound = ref(false);
    const pages = reactive({
        number: 1,
        size: 20,
        total: 0,
    });
    const txs = reactive({
        list: new Array(20).fill({
            hash: "",
            from: "",
            to: "",
            block_time: "",
        }),
    });
    const trade = reactive({
        state: true,
        detail: { tx: {} } as any,
        markdownTxt: "",
    });
    const erc20Tokens = ref<Record<string, unknown>>({});

    // 获取总条数
    async function getCount(): Promise<void> {
        const res = await getTxCount([]);
        pages.total = res.result || 0;
    }

    async function getTxList(): Promise<void> {
        loading.value = true;
        const params = [
            {
                page: {
                    number: pages.number,
                    size: pages.size,
                },
                sort: [
                    {
                        key: "height_index",
                        ascending: false,
                    },
                ],
            },
        ];
        const res = await txList(params);
        if (res.error == null) {
            txs.list = checkGroup(res.result);
        }
        loading.value = false;
    }

    function getTradeDetail(hash: string): void {
        Rpc.queryTransaction(hash).then((res) => {
            if (!res.result) {
                txNotFound.value = true;
                return;
            }
            trade.detail = res.result;
            trade.state = !tradeAccuracy(
                res.result.tx.execer,
                res.result.receipt.ty,
                res.result.receipt.tyName
            );
            if (trade.detail.tx.execer == "user.write")
                trade.markdownTxt = trade.detail.tx.payload.content;
        });
        // 获取ERC20转账记录
        getTransactionAnalysis(hash).then((res) => {
            if (res.data) {
                erc20Tokens.value = res.data;
            }
        });
    }

    function pageChange(page: number): void {
        pages.number = page;
        getTxList();
    }

    function sizeChange(size: number): void {
        pages.size = size;
        pages.number = 1;
        getTxList();
    }

    return {
        getCount,
        getTxList,
        pageChange,
        sizeChange,
        pages,
        loading,
        txs,
        trade,
        erc20Tokens,
        getTradeDetail,
        txNotFound,
    };
};
